import React from 'react';
import { X } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import './Modal.css';

const CompanyModal = ({ onClose }) => {
  const { t } = useLanguage();

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} aria-label={t('common.close')}>
          <X size={24} />
        </button>

        <div className="modal-header">
          <h2>{t('comp.title')}</h2>
        </div>

        <div className="modal-body">
          <div className="modal-image">
            <img
              src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800"
              alt=""
            />
          </div>

          <div className="modal-text">
            <h3>{t('comp.h3')}</h3>
            <p>{t('comp.p1')}</p>

            <h4>{t('comp.values')}</h4>
            <ul>
              <li><strong>{t('comp.v1')}:</strong> {t('comp.v1t')}</li>
              <li><strong>{t('comp.v2')}:</strong> {t('comp.v2t')}</li>
              <li><strong>{t('comp.v3')}:</strong> {t('comp.v3t')}</li>
              <li><strong>{t('comp.v4')}:</strong> {t('comp.v4t')}</li>
            </ul>

            <h4>{t('comp.vision')}</h4>
            <p>{t('comp.visionP')}</p>

            <h4>{t('comp.team')}</h4>
            <p>{t('comp.teamP')}</p>

            <div className="stats-container">
              <div className="stat-item">
                <div className="stat-number">35+</div>
                <div className="stat-label">{t('comp.stats.years')}</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">5000+</div>
                <div className="stat-label">{t('comp.stats.projects')}</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">100%</div>
                <div className="stat-label">{t('comp.stats.happy')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyModal;
